import { Injectable } from '@angular/core';
import { Observable, BehaviorSubject } from 'rxjs';
import { HttpService } from './http.service';
import { Hotel, CreateHotelContactRequest } from '../interfaces/hotel';
import { HotelService } from './hotel.service';

export type ContactData = Record<string, unknown>;

export interface ContactApiResponse {
  data: ContactData;
  message?: string;
}

export interface ContactSaveResponse {
  data?: ContactData;
  message?: string;
}

@Injectable({
  providedIn: 'root'
})
export class ContactInformationService {
  private showLightCardSubject: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  private selectedHotelSubject = new BehaviorSubject<Hotel | null>(null);
  selectedHotel$ = this.selectedHotelSubject.asObservable();
  public selectedHotelId = 0;

  constructor(
    private http: HttpService,
    private hotelService: HotelService,
  ) { }

  setShowLightCard(show: boolean): void {
    this.showLightCardSubject.next(show);
  }

  getShowLightCard(): Observable<boolean> {
    return this.showLightCardSubject.asObservable();
  }

  getHotelContact(): Observable<ContactApiResponse> {
    const selectedHotelId = this.hotelService.hotelId;
    return this.http.get<ContactApiResponse>(`v2/hotels/contact/${selectedHotelId}`);
  }

  /**
   * Creates the primary contact for a newly created hotel.
   * Used as the second step in hotel creation after createHotelInformation().
   */
  createHotelContact(data: CreateHotelContactRequest): Observable<ContactSaveResponse> {
    return this.http.post<ContactSaveResponse>('v2/hotels/contact', data);
  }

  saveHotelContact(data: Record<string, unknown>): Observable<ContactSaveResponse> {
    const selectedHotelId = this.hotelService.hotelId;
    return this.http.put<ContactSaveResponse>(`v2/hotels/contact/${selectedHotelId}`, data);
  }

}
